<template>
    <div class="realisation">
        <div class="photos">
          <div class="maintContainer" v-for="(image, imageIndex)  in this.images" :key="imageIndex">
            <div class="photoContainer">
              <div class="imageGallery"
                  @click="goTo(folder[imageIndex])"
                  :style="{ backgroundImage: 'url('+ getImage(image) +')', width: '300px', height: '200px' }"
              />
            </div>
            <p >{{text[imageIndex]}}</p>
          </div>
        </div>
    </div>
</template>

<script>
import jsonData from "../data/dataStudios.json";

let p = [];
let text = [];
let folder = [];
export default {
  name: "Studio",
  data() {
    return {
      rawImages: jsonData,
      index: null,
      images: p,
      text: text,
      folder: folder,
    };
  },
  mounted: function() {
    if (this.images.length == 0) {
      for (let i in this.rawImages) {
        this.images.push(this.rawImages[i].split(";")[0]);
        this.text.push(this.rawImages[i].split(";")[1]);
        this.folder.push(this.rawImages[i].split(";")[2]);
      }
    }
  },
  methods: {
    goTo: function(name) {
      this.$router.push("/studios/" + name);
    },
    getImage: function(photo) {
      let image = require.context("../assets/studio", false, /\.jpg$/);
      return image("./" + photo);
    },
  },
};
</script>
<style>
.maintContainer {
  display: inline-block;
}
.photoContainer {
  width: 300px;
  height: 200px;
  margin: 10px;
  display: inline-block;
  overflow: hidden;
}
.line {
  width: calc(69% / 2);
}
@media only screen and (min-width: 320px) and (max-width: 812px) {
  .line {
    width: calc(62% / 2);
  }
  .innerSpan {
    width: 100px;
  }
}
</style>
